import React from "react";
import { formatLocalStamp, formatMoney } from "./treasuryHelpers";

export default function TreasuryActivityPanel({ windows, series, totalSnapshots }) {
  const recent = [...series].reverse().slice(0, 4);

  return (
    <section className="atrs-workspace-section" aria-label="Treasury activity">
      <header className="atrs-workspace-heading">
        <div>
          <p className="atrs-section-kicker">Activity</p>
          <h2>Cash movement and provider float</h2>
        </div>
        {totalSnapshots ? (
          <span className="atrs-workspace-note">{totalSnapshots} balance snapshots</span>
        ) : null}
      </header>

      <div className="atrs-activity-grid">
        <div className="atrs-flow-table">
          <div className="atrs-flow-table-head">
            <span>Period</span>
            <span>Deposits</span>
            <span>Withdrawals</span>
            <span>Net flow</span>
          </div>
          {windows.map((window) => (
            <div key={window.id} className="atrs-flow-table-row">
              <strong>{window.label}</strong>
              <span className="tabular-nums">
                {formatMoney(window.inflow, { currency: "CASH", compact: true })}
                <small>{window.inCount} deposits</small>
              </span>
              <span className="tabular-nums">
                {formatMoney(window.outflow, { currency: "CASH", compact: true })}
                <small>{window.outCount} withdrawals</small>
              </span>
              <strong
                className={`tabular-nums ${window.net >= 0 ? "atrs-flow-net-up" : "atrs-flow-net-down"}`}
              >
                {window.net >= 0 ? "+" : "−"}
                {formatMoney(Math.abs(window.net), { currency: "CASH", compact: true })}
              </strong>
            </div>
          ))}
        </div>

        <div className="atrs-history-panel" aria-label="Provider float history">
          <div className="atrs-history-panel-head">
            <span>Latest provider balances</span>
            {series.length ? <span>Trend</span> : null}
          </div>
          {series.length ? (
            <>
              <div className="atrs-sparkline" aria-label="Float trend chart">
                {series.map((row) => (
                  <div key={row.id} className="atrs-spark-col">
                    <span
                      className="atrs-spark-bar"
                      style={{ height: `${Math.max(row.heightPct, 6)}%` }}
                      title={`${formatMoney(row.balance, { currency: row.currency || "RWF" })} · ${formatLocalStamp(row.recordedAt, { short: true })}`}
                    />
                  </div>
                ))}
              </div>
              <div className="atrs-history-list">
                {recent.map((row) => (
                  <div key={row.id} className="atrs-history-row">
                    <div>
                      <strong className="tabular-nums">
                        {formatMoney(row.balance, { currency: row.currency || "RWF", compact: true })}
                      </strong>
                      <span>{formatLocalStamp(row.recordedAt, { short: true })}</span>
                    </div>
                    <em className={row.delta > 0 ? "atrs-delta-up" : row.delta < 0 ? "atrs-delta-down" : ""}>
                      {row.delta ? `${row.delta > 0 ? "+" : "−"}${formatMoney(Math.abs(row.delta), { currency: row.currency || "RWF", compact: true })}` : "—"}
                    </em>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p className="atrs-empty-inline">Record a float to begin tracking balances.</p>
          )}
        </div>
      </div>
    </section>
  );
}
